import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue'), meta: { title: '首页' } },
  { path: '/about', name: 'About', component: () => import('@/views/About.vue'), meta: { title: '公司简介' } },
  { path: '/news', name: 'News', component: () => import('@/views/News.vue'), meta: { title: '新闻资讯' } },
  { path: '/news/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail.vue'), meta: { title: '新闻详情' } },
  { path: '/product', name: 'Product', component: () => import('@/views/Product.vue'), meta: { title: '产品中心' } },
  { path: '/product/:id', name: 'ProductDetail', component: () => import('@/views/ProductDetail.vue'), meta: { title: '产品详情' } },
  { path: '/case', name: 'Case', component: () => import('@/views/Case.vue'), meta: { title: '服务案例' } },
  { path: '/case/:id', name: 'CaseDetail', component: () => import('@/views/CaseDetail.vue'), meta: { title: '案例详情' } },
  { path: '/solutions', name: 'Solutions', component: () => import('@/views/Solutions.vue'), meta: { title: '解决方案' } },
  { path: '/message', name: 'Message', component: () => import('@/views/Message.vue'), meta: { title: '在线留言' } },
  { path: '/contact', name: 'Contact', component: () => import('@/views/Contact.vue'), meta: { title: '联系我们' } }
]

const router = new VueRouter({
  mode: 'history',
  base: '/web/',
  routes,
  scrollBehavior() { return { x: 0, y: 0 } }
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || '首页') + ' - 企业官网'
  next()
})

export default router
